import { Grid } from '@material-ui/core'
import styled, { css } from 'styled-components'
import { Typography } from '~/components/typography'
import { appStore } from '~/stores'

export const headerTitleStyle = css`
	color: ${appStore.getTheme.colors.primary.main};
	font-weight: ${appStore.getTheme.typography.h5.fontWeight};
	font-size: ${appStore.getTheme.typography.h5.fontSize};
	margin-bottom: ${appStore.getTheme.spacing(2)}px;
`

export const sectionBoxStyle = css`
	margin-bottom: ${appStore.getTheme.spacing(3)}px;
	padding: ${appStore.getTheme.spacing(2)}px;
	border: ${appStore.getTheme.borders[1]};
	border-radius: 8px;
	background-color: ${appStore.getTheme.colors.background.element.veryLight};
`

export const headerRowStyle = css`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: ${appStore.getTheme.spacing(2)}px;
`

export const sectionListStyle = css`
	margin-top: ${appStore.getTheme.spacing(2)}px;
`

export const emptyTextStyle = css`
	color: ${appStore.getTheme.colors.text.muted};
	font-style: italic;
	text-align: center;
	padding: ${appStore.getTheme.spacing(2)}px;
`

export const itemRowStyle = css`
	background-color: white;
	border: ${appStore.getTheme.borders[1]};
	border-radius: 4px;
	margin-bottom: ${appStore.getTheme.spacing(1)}px;
	padding: ${appStore.getTheme.spacing(2)}px;
`

// Dialog Components
export const StyledDialog = styled.div`
	width: 600px;
	border-radius: 16px;
	padding: 0;
	display: flex;
	flex-direction: column;
	height: 90vh;
	max-height: 90vh;
	overflow: hidden;
`

export const StyledDialogHeader = styled.div`
	padding: 24px 24px 0 24px;
	flex-shrink: 0;
	background-color: #ffffff;
	position: sticky;
	top: 0;
	z-index: 1;
`

export const StyledDialogTitle = styled.h5`
	font-weight: 700;
	font-size: 20px;
	line-height: 1.6em;
	color: #263349;
	margin: 0;
	margin-bottom: 8px;
	width: 372px;
`

export const StyledDialogDescription = styled.p`
	font-weight: 400;
	font-size: 16px;
	line-height: 1.75em;
	color: #333335;
	margin: 0;
`

export const StyledScrollableContent = styled(Grid)`
	padding: 0 24px;
	padding-top: 24px;
	padding-bottom: 24px;
	overflow-y: auto;
	overflow-x: hidden;
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.gap || 24}px;
	scrollbar-width: thin;
	-ms-overflow-style: auto;
	min-height: 0;

	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: #a8a8a8;
	}
`

export const StyledDialogFooter = styled.div`
	padding: 24px;
	border-top: 1px solid #e6e6e6;
	display: flex;
	justify-content: stretch;
	align-items: stretch;
	gap: 16px;
	flex-shrink: 0;
	background-color: #ffffff;
	position: sticky;
	bottom: 0;
	z-index: 1;
`

export const StyledDialogContent = styled.div`
	padding: ${appStore.getTheme.spacing(3)}px;
	max-height: 80vh;
	overflow-y: auto;
`

export const StyledDialogActions = styled.div`
	padding: ${appStore.getTheme.spacing(2)}px ${appStore.getTheme.spacing(3)}px;
	border-top: ${appStore.getTheme.borders[1]};
	display: flex;
	justify-content: flex-end;
	gap: ${appStore.getTheme.spacing(1)}px;
`

export const StyledSecondaryButton = styled.button`
	border: 2px solid #263349;
	border-radius: 8px;
	padding: 14px 24px;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 16px;
	line-height: 1.75em;
	color: #263349;
	background-color: transparent;
	flex: 1;
	height: 48px;
	cursor: pointer;

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`

export const StyledPrimaryButton = styled.button`
	background-color: #263349;
	border-radius: 8px;
	padding: 14px 24px;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 16px;
	line-height: 1.75em;
	color: #f8f8f8;
	border: none;
	flex: 1;
	height: 48px;
	cursor: pointer;

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`

// Section Components
export const StyledSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`

export const StyledSectionTitle = styled.h3`
	font-weight: 700;
	font-size: 20px;
	line-height: 1.6em;
	color: #333335;
	margin: 0;
`

export const StyledSectionContent = styled.div`
	border: 1px solid #e6e6e6;
	border-radius: 8px;
	padding: 16px 16px 0 16px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`

export const StyledAddButton = styled.button`
	background-color: #eef2ff;
	border: 1px solid #90abff;
	border-radius: 8px;
	padding: 13px 0;
	text-transform: none;
	color: #263349;
	font-weight: 400;
	width: 100%;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
`

export const StyledEmptyState = styled.div`
	color: #999;
	font-style: italic;
	text-align: center;
`

export const StyledBottomSpacer = styled.div`
	height: 200px;
`

export const SectionTitle = styled.h6`
	${headerTitleStyle}
	margin: 0;
	font-size: ${appStore.getTheme.typography.h6.fontSize};
`

export const SectionBox = styled.div`
	${sectionBoxStyle}
`

export const HeaderRow = styled.div`
	${headerRowStyle}
`

export const ItemRow = styled.div`
	${itemRowStyle}
`

export const EmptyText = styled.p`
	${emptyTextStyle}
	margin: 0;
`

export const AddButtonLabel = styled(Typography)(({ theme }) => ({
	color: theme.palette?.hyperLink?.medium,
	fontWeight: 700,
}))
